// @flow

import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';
import classnames from 'classnames';
import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';
import Icon from 'sail/Icon';
import {warning, check, cancel} from 'sail/Icon/Assets';
import type {StateDiagramNodeState} from '../types';

import './StateDiagram.scss';

type StateDiagramNodeData = {|
  text: string,
  state: StateDiagramNodeState,
|};

type StateDiagramNodeProps = {|
  data: StateDiagramNodeData,
|};

const ICONS = {
  success: check,
  warning,
  error: cancel,
  canceled: cancel,
};

export const StateDiagramNode = ({data}: StateDiagramNodeProps) => {
  const {text, state} = data;

  const textColor = !state || state === 'neutral' ? 'gray900' : 'white';
  const icon =
    !state || state === 'neutral' ? null : (
      <Box margin={{right: 8}}>
        <Icon icon={ICONS[state]} color={'white'} />
      </Box>
    );

  return (
    <Box
      className={classnames(
        'StateDiagramNode',
        `StateDiagramNode-${state || 'neutral'}`,
      )}
      padding={{vertical: 16, horizontal: 24}}
      flex={{alignItems: 'center', justifyContent: 'center'}}
    >
      <Handle
        type="target"
        position={Position.Top}
        id="top"
        style={{left: '50%', top: '0%'}}
      />
      <Handle
        type="source"
        position={Position.Top}
        id="top"
        style={{left: '50%', top: '0%'}}
      />
      <Handle
        type="target"
        id="left"
        position={Position.Left}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Left}
        id="left"
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        style={{left: '50%', top: '100%'}}
      />
      <Handle
        type="target"
        position={Position.Bottom}
        id="bottom"
        style={{left: '50%', top: '100%'}}
      />
      <Box flexBasis="100%" flex={{alignItems: 'center'}}>
        {icon}
        <BodyAlt align="center" color={textColor}>
          {React.Children.toArray(text)}
        </BodyAlt>
      </Box>
      <Handle
        type="target"
        id="right"
        position={Position.Right}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{top: '50%'}}
      />
    </Box>
  );
};
